/*
 * Module for the MemberDirect profile page
*/

rs.module("content/user/profile",

    [ ],

    function () {

        //
        // Initialize
        //
        function initialize(listApi) {

            // load the corresponding detail when a list item is clicked
            listApi.onItemClick(function (e, context) {

                // If we don't have a DetailUrl, don't do anything.
                if (!context.DetailUrl) {
                    return;
                }

                listApi.detail.updateTitle(context.DetailTitle)

                $.get(context.DetailUrl)
                    .done(function (html) {

                        listApi.detail.loadDetail(html);
                    })
                    .fail(function () {

                        // if the detail retrieve failed, show empty detail
                        listApi.detail.clearDetail();
                    });
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);